export default "__VITE_ASSET__1qEtlmwB__"